const Heading = (props) => {
  return (
    <div className="info">
      <h2 className="text-warning">{props.h2}</h2>
      <h3>{props.h3}</h3>
      <p className="fs-6 text-white-50">{props.p}</p>
    </div>
  );
};

export default Heading;
